  <button id="refresh-button" class="refresh-button btn refresh-table-button print-hide"><fa-icon [icon]="refreshIcon"></fa-icon> Refresh</button>

